import type { StatusMapping } from './types';

/**
 * WAVESPEED 状态映射配置（所有模型统一使用）
 */
export const wavespeedStatusMapping: StatusMapping = {
    taskIdPath: 'data.id',
    statePath: 'data.status',
    success: ['completed'],
    failed: ['fail', 'failed'],
    processing: ['processing'],
    imageUrlPath: 'data.outputs[0]',
    errorPath: 'data.error',
};
